<template>
  <div>
    <loader-dialog :is-dialog-visible="isDialogVisible2" />
    <v-card class="mb-8">
      <div class="m-2">
      </div>
    </v-card>
    <v-card>
      <v-data-table
        :loading="isDialogVisible"
        loading-text="Chargement..."
        :headers="headers"
        :items="$store.getters['alert/alerts']"
        :items-per-page="$store.getters['alert/per_page']"
        :page.sync="$store.getters['alert/current_page']"
        dense
        fixed-header
        height="500"
        hide-default-footer
        @page-count="currentPage = $event"
      >
        <template #[`item.created_at`]="{item}">
          {{ formattingDate(`${item.start_date}`) }}
        </template>
        <template #[`item.created_at`]="{item}">
          {{ formattingDate(`${item.created_at}`) }}
        </template>
        <template #[`item.updated_at`]="{item}">
          {{ formattingDate(`${item.updated_at}`) }}
        </template>
        <template #[`item.deleted_at`]="{item}">
          {{ item.deleted_at ? formattingDate(`${item.deleted_at}`) : null }}
        </template>
      </v-data-table>

      <v-card-text class="pt-2">
        <v-row>
          <v-col
            lg="2"
            cols="3"
          >
            <v-text-field
              :value="$store.state.alert.field.paginate"
              label="Lignes par page:"
              type="number"
              min="-1"
              max="15"
              hide-details
              @input="getEltsPerPage"
            ></v-text-field>
          </v-col>

          <v-col
            lg="10"
            cols="9"
            class="d-flex justify-end"
          >
            <v-pagination
              v-model="currentPage"
              total-visible="6"
              :length="lastPage"
              @input="getElts"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CarDetailsDialog from '@core/components/user/CarDetailsDialog'
import LoaderDialog from '@core/components/dialogs/LoaderDialog'
import ConfirmDialog from '@core/components/dialogs/ConfirmDialog'
import { mapGetters, mapState } from 'vuex'
import {
  mdiAccountLock,
  mdiDeleteOutline,
  mdiDotsVertical, mdiEyeOutline, mdiLockOpen,
  mdiPencilOutline, mdiPlus,
  mdiSquareEditOutline,
} from '@mdi/js'
import { formatDate } from '@core/date/dateFunctions'
import { onMounted, ref } from '@vue/composition-api'
import store from '@/store'

export default {
  name: 'UserAlertsList',
  components: { CarDetailsDialog, LoaderDialog, ConfirmDialog },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    user_id: {
      type: String,
      default: null,
    },
  },

  setup(props) {
    const isLockedColor = {
      false: 'info',
      true: 'success',
    }

    const currentPage = ref(null)
    const lastPage = ref(null)
    const dialogDelete = ref(false)
    const isDialogVisible = ref(false)
    const isDialogVisible2 = ref(false)
    const dialog = ref(false)

    const formattingDate = date => formatDate(date)

    // eslint-disable-next-line no-unused-vars
    const openItem = item => {
      isDialogVisible2.value = true
      store.dispatch('alert/getAlertById', item).then(() => {
        isDialogVisible2.value = false
      })
      dialog.value = true
    }

    const closeDialog = () => {
      dialog.value = false
    }

    const getElts = (page = 1) => {
      isDialogVisible.value = true
      store.state.alert.field.user_id = props.user_id
      store.dispatch('alert/getAlertsList', { page, field: store.state.alert.field }).then(() => {
        currentPage.value = store.getters['alert/current_page']
        lastPage.value = store.getters['alert/last_page']
        isDialogVisible.value = false
      })
    }

    const filterElts = () => {
      setTimeout(() => {
        getElts()
      }, 1000)
    }

    // eslint-disable-next-line camelcase
    const getEltsPerPage = per_page => {
      // eslint-disable-next-line camelcase
      if (per_page !== null) {
        isDialogVisible.value = true
        // eslint-disable-next-line camelcase
        store.state.alert.field.paginate = per_page
        store.state.alert.field.user_id = props.user_id
        store.dispatch('alert/getAlertsList', {
          page: store.getters['alert/current_page'],
          field: store.state.alert.field,
        }).then(() => {
          currentPage.value = store.getters['alert/current_page']
          lastPage.value = store.getters['alert/last_page']
          isDialogVisible.value = false
        })
      }
    }

    const loading = () => {
      isDialogVisible.value = !isDialogVisible.value
    }

    onMounted(() => {
      getElts(store.getters['alert/current_page'])
    })

    return {
      getEltsPerPage,
      getElts,
      formattingDate,
      filterElts,
      openItem,
      closeDialog,
      loading,
      currentPage,
      lastPage,
      dialog,
      dialogDelete,
      isDialogVisible,
      isDialogVisible2,
      headers: [
        { text: 'DEPART', value: 'city' },
        { text: 'ARRIVEE', value: 'destination' },
        { text: 'NOMBRE DE PASSAGERS', value: 'nb_passagers' },
        { text: 'DATE DE DEPART', value: 'start_date' },
        { text: 'DATE DE CREATION', value: 'created_at' },
        { text: 'DATE DE MISE A JOUR', value: 'updated_at' },
        { text: 'DATE DE SUPPRESSION', value: 'deleted_at' },
      ],
      itemsPerPage: parseInt(store.state.alert.field.paginate, 10),

      // icons
      icons: {
        mdiSquareEditOutline,
        mdiDotsVertical,
        mdiDeleteOutline,
        mdiPencilOutline,
        mdiAccountLock,
        mdiLockOpen,
        mdiPlus,
        mdiEyeOutline,
      },
    }
  },
}
</script>

<style scoped>

</style>
